import actions from '../../../../../actions/fortnite-game/activeUsers.actions';
import {getActiveUsersState} from '../../../../../selectors/fortnite-game/activeUsersSelector';
import useWidgetData from '../hooks/useWidgetData';

import {WidgetState} from '../../../../../types';
import {WidgetDataParams} from '../types';

const useActiveUsersData = (params: WidgetDataParams): WidgetState => {
    const widgetData: WidgetState = useWidgetData({
        widgetAction: actions.getActiveUsers,
        resetAction: actions.resetData,
        getWidgetState: getActiveUsersState,
        ...params
    });

    return {
        ...widgetData
    };
};

export default useActiveUsersData;
